import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import Menu from '@mui/material/Menu';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Button, Container, Stack } from '@mui/material';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const Sitemark = ()=>{

    const toHome=()=>{
        window.location.href = "/"
    }

    return (
        <Box
            onClick={() => toHome()}
            component="img"
          
            sx={{
                flexGrow:1,
                height: 56,
                width: 128,
                maxHeight: { xs: 28, sm:48, md: 56 },
                maxWidth: { xs: 64, sm: 112, md: 128 },
                cursor:"pointer"
            }}
            alt="The house from the offer."
            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/media%2Flogos%2Flog_v2.png?alt=media&token=44bb8137-e865-403e-8e89-da8c80a0f018"
            />
 
    );
}

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    backgroundColor: 'white',
}));

export default function PrimaryAppBar(props ) {
    const {location, address} = props
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
  
    const toggleDrawer = (newOpen) => () => {
      setOpen(newOpen);
    };
  
    const scrollToSection = (sectionId) => {
      const sectionElement = document.getElementById(sectionId);
      const offset = 128;
      if (sectionElement) {
        const targetScroll = sectionElement.offsetTop - offset;
        sectionElement.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({
          top: targetScroll,
          behavior: 'smooth',
        });
        setOpen(false);
      }
    };

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const onClickLocationConfiguration = (event)=>{
        location()
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
    <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
        id={menuId}
        keepMounted
        transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
    >
        <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
        <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
    <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
    >
        <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
            <Badge badgeContent={4} color="error">
            <MailIcon />
            </Badge>
        </IconButton>
        <p>Messages</p>
        </MenuItem>
        <MenuItem>
        <IconButton
            size="large"
            aria-label="show 17 new notifications"
            color="inherit"
        >
            <Badge badgeContent={17} color="error">
            <NotificationsIcon />
            </Badge>
        </IconButton>
        <p>Notifications</p>
        </MenuItem>
        <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
        >
            <AccountCircle />
        </IconButton>
        <p>Profile</p>
        </MenuItem>
    </Menu>
    );

    return (
        <Container maxWidth={'xl'} disableGutters  component='main'>
        <AppBar  variant="no-shadow" position="static">
            <StyledToolbar>
                <Sitemark />
                <Button  onClick={() => onClickLocationConfiguration()} variant="header" startIcon={<LocationOnIcon />} sx={{ mx: 1 }}>
                    <Stack>
                        <Typography variant="caption" textAlign={"left"}>
                            {address?.formatted_address}
                        </Typography>
                        <Typography variant="body" sx={{fontWeight:"bolder"}} textAlign={"left"}>Actualizar ubicación</Typography>
                    </Stack>
                </Button>
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                    <MenuItem variant="appbar" onClick={() => scrollToSection('app')}>
                    App
                    </MenuItem>
                    <MenuItem variant="appbar" onClick={() => scrollToSection('news')}>
                    News
                    </MenuItem>
                    <MenuItem  variant="appbar" onClick={() => scrollToSection('products')}>
                    Products
                    </MenuItem>
                    <MenuItem  variant="appbar" onClick={() => scrollToSection('faq')}>
                    FAQ
                    </MenuItem>
                    {/*<Button href="/login" variant="header" startIcon={<PersonOutlineOutlinedIcon />} sx={{ mx: 1, color:"white" }}>
                        <Stack>
                            <Typography variant="caption">
                                Iniciar sesión
                            </Typography>
                            <Typography variant="body"sx={{fontWeight:"bolder"}}>Cuenta</Typography>
                        </Stack>
                    </Button>*/}
                </Box>
            </StyledToolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
        </Container>
    );
}